import React, {useState, useEffect, useRef} from "react";
import axios from "../libs/httpClient";
import {host} from "../libs/webRTC";
import {Container, Jumbotron, Button} from "react-bootstrap";
import '../styles/DeleteSession.css';
import fronLogger from "../libs/logger";

import StudentsTable from "../components/studentslist/StudentsTable";

let tableData = [];
let timeout = null;
let intervalID;

function delete_from_bd() {
    let sessionsToDelete = [];
    let token = document.getElementById("token").value;
    fronLogger(token, "Удалена сессия", "ok", "DeleteSession.js");
    sessionsToDelete.push(token);
    axios.post(`${host}/service/token/delete`, [sessionsToDelete])
        .then(res=>{
            alert(`Удалена сессия: ${res.data["tokens"].toString()}`);
            document.getElementById("token").value = "";
        });
}

export function delete_by_token(token){
    let sessionsToDelete = [];
    if (window.confirm(`Вы уверены что хотите удалить сессию с токеном - ${token} ?`)) {
        sessionsToDelete.push(token);
        fronLogger(token, "Добавлен в список удаления", "ok", "DeleteSession.js");
        axios.post(`${host}/service/token/delete`, [sessionsToDelete])
            .then(res=>{
                alert(`Удалена сессия: ${res.data["tokens"].toString()}`);
                fronLogger(token, "Удалена сессия", "ok", "DeleteSession.js");
                document.getElementById("token").value = "";
                window.location.reload();
            });
    }
}


async function deleteNotSentSessions() {
    let sessionsToDelete = [];
    try {
        const res = await axios.post(`${host}/tables/sessions/selection`, { filters: { state: { filterType: 'SELECT', comparator: '=', filterVal: 'Не отправлено' } } });
        sessionsToDelete = res.data.ids;
    } catch (err) {
        console.log(err);
        fronLogger(err, "error", "DeleteSession.js");
        alert(err.response?.data?.error || "Не удалось получить выборку для удаления.");
        return;
    }

    try {
        await axios.post(`${host}/service/token/delete`, [sessionsToDelete])
            .then(res => {
                alert(`Удалены ${sessionsToDelete.length} сессий. Сессии: ${sessionsToDelete}`);
                fronLogger(0, "Удалены" + sessionsToDelete, "ok", "DeleteSession.js");
            });
    } catch (err) {
        console.log(err);
        fronLogger(err, "error", "DeleteSession.js");
    }
}

function deleteRoom() {
    let token = document.getElementById("token").value;
    axios.delete(`${host}/service/token/delete/${token}`).then(res=>{
        alert(`Удалена сессия: ${res.data["tokens"].toString()}`);
        fronLogger(token, "Удалена комната", "ok", "DeleteSession.js");
        document.getElementById("token").value = "";
    });
}



export function getDataTable(data){
    tableData = data;
    return tableData;
}

function TimerAndDeleteButton(){
    const mounted = useRef(true);
    const selecting = useRef(false);
    useEffect(() => () => {
        mounted.current = false;
        clearInterval(intervalID);
        clearTimeout(timeout);
        timeout = null;
    }, []);
    const [isDelete, setIsDelete]= useState(false);
    const [timer, setTimer]= useState(0);
    const [submitting, setSubmitting] = useState(false);
    const [deleteError, setDeleteError] = useState('');
    let showDeleteButton = true;
    const delete_all_sessions_in_table = async () =>{
        if (submitting || selecting.current) return;
        setDeleteError('');
        if(timeout === null){
            if (!tableData || tableData.loading || tableData.error) return;
            if (!Object.keys(tableData.payload.filters || {}).length){
                alert("Нельзя удалить всю базу данных сессий!\n");
                fronLogger(0, "Пользователь пытался удалить всю базу данных", "warning", "DeleteSession.js");
                return;
            }
            if (!tableData.total) {
                alert('Нет сессий для удаления.');
                return;
            }
            let arrForDelete;
            selecting.current = true;
            setSubmitting(true);
            try {
                const selection = await axios.post(`${host}/tables/sessions/selection`, tableData.payload);
                arrForDelete = selection.data.ids.map(_id => ({ _id }));
            } catch (error) {
                if (mounted.current) setDeleteError(error.response?.data?.error || 'Не удалось получить выборку для удаления.');
                return;
            } finally {
                selecting.current = false;
                if (mounted.current) setSubmitting(false);
            }
            if (!mounted.current) return;
            fronLogger(0, "Составлен список сессий для удаления по кнопке" + arrForDelete, "ok", "DeleteSession.js");
            if(window.confirm(` Вы хотите удалить все отфильтрованные сессии?\n Количество сессий которые будут удалены - ${arrForDelete.length}`)){
                setIsDelete(true);
                let t =0;
                setTimer(0);
                showDeleteButton = false;
                intervalID = setInterval(() => {
                    if(t !== 10){
                        t += 1;
                        setTimer(t);
                        setIsDelete(true);
                    }

                }, 1000);
                timeout = setTimeout(() =>{
                    setIsDelete(false);
                    setSubmitting(true);
                    let sessionsToDelete = [];
                    for(let i in arrForDelete){
                        sessionsToDelete.push(arrForDelete[i]._id);
                        fronLogger(arrForDelete[i]._id, "Сессия удалена!", "info", "DeleteSession.js");
                    }

                    console.log("ses: ",sessionsToDelete);
                    axios.post(`${host}/service/token/delete`, [sessionsToDelete])
                        .then(res=>{
                            alert(`Удалено ${arrForDelete.length} сессии`);
                            window.location.reload();
                        })
                        .catch(() => setDeleteError('Не удалось удалить сессии. Проверьте соединение и повторите попытку.'))
                        .finally(() => setSubmitting(false));

                    clearInterval(intervalID);
                    clearTimeout(timeout);
                    timeout = null;
                }, 10000);
            }
        }else{
            alert("Идёт удаление сессий!");
        }
    };

    const stopDelete = () =>{
        setIsDelete(false);
        clearInterval(intervalID);
        clearTimeout(timeout);
        timeout = null;
    };

    const showDialogToCancelDelete = () => {
        return(
            <div style={{display:"flex",
                flexDirection: "column",
                alignItems: "center"}}>
                <p style={{background: "palegoldenrod",
                    borderRadius: "6px",
                    padding: "8px"}}>
                    Отменить удаление можно в течение 10 секунд - {timer}
                </p>
                <div>
                    <Button onClick={stopDelete}>Не удалять</Button>
                </div>
            </div>
        );
    }

    return(
        <div style={{display:"flex",
            alignItems: "flex-end",
            flexDirection: "column",
            margin: "22px"}}>
            {isDelete && showDialogToCancelDelete()}
            {deleteError && <p role="alert">{deleteError}</p>}
            {!isDelete && (timeout === null) && <Button disabled={submitting} variant={"danger"} onClick={delete_all_sessions_in_table}>Удалить данные из таблицы ниже</Button>}
        </div>
    );
}



export default function DeleteSession(props) {
    useEffect(() => { tableData = null; return () => { tableData = null; }; }, []);

    return (
        <div>
            <Jumbotron>
                <Container>
                    <input type="text" placeholder="Type token..." id="token"/>
                    <Button className="session_delete"  onClick={() => delete_from_bd()} >
                        Удалить сессию
                    </Button>
                    <Button className="notsended_delete" onClick={() => deleteNotSentSessions()} >
                        Удалить неотправленные сессии
                    </Button>
                    <Button className="room_delete" onClick={() => deleteRoom()} >
                        Удалить комнату
                    </Button>
                </Container>
                <Container>
                </Container>
            </Jumbotron>
            <TimerAndDeleteButton/>
            <Container fluid>
                <StudentsTable mode={5}/>
            </Container>
        </div>
    );
}
